import React, { useState } from 'react';
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core";
import QRCode from 'qrcode';
import { useSelector } from 'react-redux';
import { getQr } from '../../../../redux/reducers/act-reducer';

export const useStyles = makeStyles(() => ({
    text: {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
    },
    qrReal: {
        height: '200px',
        maxWidth: '200px',
        marginBottom: '40px'
    },
    qr: {
        height: '50px',
        maxWidth: '50px',
    }
}))



const QrCode = () => {
    const [link, setLink] = useState('')
    
    const getQrString = useSelector(getQr)
    


    if (getQrString !== null ) {
     if (getQrString.qrcode_web !== null) {
        const adress = 'https://ma.gasoilcenter.ru/qrcode/' + getQrString.qrcode_web
        QRCode.toDataURL(adress, { errorCorrectionLevel: 'Q' })
        .then(url => {
            setLink(url) 
        })
        .catch(err => {
            console.error(err)
        })
    }}
    const classes = useStyles()

    return (
        <>
        {link !== '' ?
            <div>
                <Typography className={classes.text} variant='h6'>Документ защищен QR кодом</Typography>
                <div className={classes.qrReal}>
                    <img  src={link} />
                </div>
            </div>
            :
            <>  
                <Typography className={classes.text} variant='h6'>Для создания QR подпишите документ </Typography>
            </>
        }  
          
        </>
    )

}

export default QrCode;
